var map = {
	"./about": 4,
	"./about-2": 5,
	"./about-2.jpg": 5,
	"./about-me": 6,
	"./about-me.jpg": 6,
	"./about-old": 7,
	"./about-old.jpg": 7,
	"./about-wct": 8,
	"./about-wct-2": 9,
	"./about-wct-2.jpg": 9,
	"./about-wct.jpg": 8,
	"./about.jpg": 4,
	"./android-chrome-192x192": 10,
	"./android-chrome-192x192.png": 10,
	"./android-chrome-512x512": 11,
	"./android-chrome-512x512.png": 11,
	"./apple-touch-icon": 12,
	"./apple-touch-icon.png": 12,
	"./facebook": 13,
	"./facebook.svg": 13,
	"./favicon-16x16": 14,
	"./favicon-16x16.png": 14,
	"./favicon-32x32": 15,
	"./favicon-32x32.png": 15,
	"./favicon.ico": 41,
	"./gymfinity-loho": 16,
	"./gymfinity-loho.svg": 16,
	"./home": 17,
	"./home-old": 18,
	"./home-old.jpg": 18,
	"./home.jpg": 17,
	"./instagram": 19,
	"./instagram.svg": 19,
	"./mermaid": 1,
	"./mermaid-green": 20,
	"./mermaid-green.png": 20,
	"./mermaid.png": 1,
	"./mermaid.svg": 42,
	"./mermaid_cream": 21,
	"./mermaid_cream.png": 21,
	"./mstile-150x150": 22,
	"./mstile-150x150.png": 22,
	"./safari-pinned-tab": 23,
	"./safari-pinned-tab.svg": 23,
	"./tomasz": 24,
	"./tomasz.jpg": 24,
	"./warsaw": 25,
	"./warsaw.jpg": 25,
	"./warsaw_coffee_tour_cream": 2,
	"./warsaw_coffee_tour_cream.png": 2,
	"./warsaw_coffee_tour_cream.svg": 43,
	"./warsaw_coffee_tour_green": 3,
	"./warsaw_coffee_tour_green.png": 3,
	"./warsaw_coffee_tour_green.svg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;